var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckgreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 0.833008C4.04261 0.833008 0.833984 4.04163 0.833984 7.99967C0.833984 11.9577 4.04261 15.1663 8.00065 15.1663C11.9587 15.1663 15.1673 11.9577 15.1673 7.99967C15.1673 4.04163 11.9587 0.833008 8.00065 0.833008Z",
    fill: "#14904A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07812 8.82812L6.73197 10.3281L11.5781 5.82812",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckgreen);
export default __webpack_public_path__ + "static/media/checkgreen.8d1751a5f2a5d45f9eda4f91f8a22267.svg";
export { ForwardRef as ReactComponent };